import { Dialog } from 'vant'

export function confirm(message, opt = {}) {
  const { confirm, close } = opt

  Dialog.confirm({
    title: '提示',
    message: message,
    className: 'submit-confirm',
    confirmButtonText: '确认无误',
    cancelButtonText: '修改'
  })
    .then(() => {
      confirm && confirm()
    })
    .catch(() => {
      close && close()
    })
}